var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12.747,
    viewBox: "0 0 20 12.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_1",
    "data-name": "view 1",
    transform: "translate(0 -3.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M19.873,9.611C19.694,9.366,15.437,3.626,10,3.626S.305,9.366.127,9.61a.66.66,0,0,0,0,.778c.178.244,4.436,5.985,9.873,5.985s9.694-5.74,9.873-5.984A.659.659,0,0,0,19.873,9.611ZM10,15.055c-4.005,0-7.474-3.81-8.5-5.055C2.525,8.753,5.986,4.945,10,4.945S17.473,8.754,18.5,10C17.475,11.247,14.014,15.055,10,15.055Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M10,6.044A3.956,3.956,0,1,0,13.956,10,3.961,3.961,0,0,0,10,6.044Zm0,6.593A2.637,2.637,0,1,1,12.637,10,2.64,2.64,0,0,1,10,12.637Z",
    fill: "#c19444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2eaaeb385aafcd986c88a07b0b692e73.svg";
export { ForwardRef as ReactComponent };